export const storeApi = {
  getPhysicalShop: {
    server: 'api/ucenter/physicalShop/queryPageV2',
    method: 'post',
  },
  getPhysicalShopView: {
    server: 'api/ucenter/physicalShop/view',
    method: 'get',
  },
  physicalShopCreate: {
    server: 'api/ucenter/physicalShop/create',
    method: 'post',
  },
  physicalShopUpdate: {
    server: 'api/ucenter/physicalShop/update',
    method: 'post',
  },
  physicalShopExport: {
    server: 'api/ucenter/physicalShop/info/export',
    method: 'post',
    responseType: 'blob',
  },
  // 整改记录
  getShopDecorateRecordPage: {
    server: 'api/ucenter/shop/decorateRecord/page',
    method: 'post',
  },
  decorateRecordCreate: {
    server: 'api/ucenter/shop/decorateRecord/create',
    method: 'post',
  },
  decorateRecordUpdate: {
    server: 'api/ucenter/shop/decorateRecord/update',
    method: 'post',
  },
  decorateRecordDelete: {
    server: 'api/ucenter/shop/decorateRecord/delete',
    method: 'post',
  },
  decorateRecordExport: {
    server: 'api/ucenter/shop/decorateRecord/export',
    method: 'post',
    responseType: 'blob',
  },
  samplePage: {
    server: '/api/ucenter/shop/sample/page',
    method: 'post',
  },
  sampleCreate: {
    server: 'api/ucenter/shop/sample/create',
    method: 'post',
  },
  sampleUpdate: {
    server: 'api/ucenter/shop/sample/update',
    method: 'post',
  },
  sampleDelete: {
    server: 'api/ucenter/shop/sample/delete',
    method: 'post',
  },
  sampleExport: {
    server: 'api/ucenter/shop/sample/export',
    method: 'post',
    responseType: 'blob',
  },
  // 表单配置
  // /api/ucenter/shop/baseFormConfig/page
  baseFormConfigPage: {
    server: 'api/ucenter/shop/baseFormConfig/page',
    method: 'post',
  },
  baseFormConfigDetail: {
    server: 'api/ucenter/shop/baseFormConfig/detail',
    method: 'get',
  },
  baseFormConfigUpdate: {
    server: 'api/ucenter/shop/baseFormConfig/update',
    method: 'post',
  },
  processConfigPage: {
    server: 'api/ucenter/processConfig/page',
    method: 'post',
  },
  physicalShopUpdateStatus: { server: 'api/ucenter/physicalShop/updateStatus', method: 'post' }, //实体门店--修改状态
  pageFindActiveByMongo: {
    server: 'api/ucenter/physicalShop/process/pageFindActiveByMongo',
    method: 'post',
  },
  decorateRecordAccept: {
    server: 'api/ucenter/shop/decorateRecord/accept',
    method: 'post',
  },
  getShopInfoChangeLogList: {
    server: 'api/ucenter/physicalShop/getShopInfoChangeLogList',
    method: 'get',
  },
  processConfigHasAuth: {
    server: 'api/ucenter/processConfig/hasAuth',
    method: 'get',
  },
  getApplyingProcess: {
    server: 'api/ucenter/getApplyingProcess',
    method: 'get',
  },
  shopTransferRecord: {
    server: 'api/ucenter/physicalShop/shopTransferRecord/page',
    method: 'post',
  },
}
